import { useEffect } from 'react'
import { UseGetListOptions } from '@/service-library/core-hooks/useGetList'
import { useGetDocuments } from '@/service-library/hooks/documents'
import { Document } from '@/types/documents'

export default function useGetAllDocuments(
  options: UseGetListOptions<Document> = {},
) {
  const query = useGetDocuments(options)
  const { hasNextPage, isFetching, isRefetching, fetchNextPage, isPending } =
    query

  const fetchData = options.enabled || options.enabled === undefined
  const isFetchingAll =
    (fetchData && isPending) || hasNextPage || (isFetching && !isRefetching)

  useEffect(() => {
    if (fetchData && hasNextPage && !isFetching) {
      fetchNextPage()
    }
  }, [fetchData, fetchNextPage, hasNextPage, isFetching, options.enabled])

  return { isFetchingAll, ...query }
}
